// extracted by mini-css-extract-plugin
export default {"recentConversations":"recentConversations__itta4a_8Asj8"};